import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import { iit } from "./data";
import FAQ from "./commonfaq";
import { neetiitjee } from "./faqdata";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";
const whyStartEarly = [
    "Lay a solid groundwork in Physics, Chemistry, Biology, and Mathematics.",
    "Develop analytical thinking, logical reasoning, and problem-solving skills.",
    "Gain early exposure to competitive exam patterns and time-tested strategies.",
    "Improve time management and exam confidence through regular mock tests.",
  ];

  const facilities = [
    "Digital smart classrooms with interactive learning tools.",
    "Fully equipped science laboratories for hands-on experiments.",
    "Dedicated doubt-solving zones for one-on-one mentoring.",
    "A stress-free learning environment with activity-based concepts and real-world applications.",
  ];

  const exams = [
    "IIT-JEE Mains & Advanced",
    "NEET-UG",
    "National & International Olympiads",
    "NTSE & other talent exams",
  ];
const seopages = {
    title: "IIT-JEE & NEET Foundation in Hyderabad | Rankridge School",
    description:
      "Start your IIT-JEE & NEET journey early with Rankridge Foundation Program (Grades 6–10). Concept clarity, exam strategy, and top-rank preparation in Hyderabad.",
    keywords: "iit jee foundation hyderabad, neet foundation hyderabad, school level iit jee coaching hyderabad, school level neet coaching hyderabad, foundation course for iit jee hyderabad, foundation course for neet hyderabad, rankridge iit jee foundation, rankridge neet foundation, competitive exam foundation hyderabad, best foundation school hyderabad, grades 6 to 10 iit jee coaching hyderabad, grades 6 to 10 neet coaching hyderabad, concept building for competitive exams hyderabad, early preparation for iit jee hyderabad, early preparation for neet hyderabad, best science foundation hyderabad, math foundation hyderabad, physics chemistry biology foundation hyderabad, exam strategy coaching hyderabad, top rank foundation program hyderabad",
    canonical_path: "https://rankridgeschools.com/primary-school-education/",
    og_description: "",
    og_image: "",
  };

const title=" IIT-JEE & NEET Foundation"
 const description="The middle and secondary years are where curiosity meets challenge — where students sharpen their understanding and begin preparing for big goals. At Rankridge Schools, our Middle & Secondary Education programme supports learners from Grade 6 through Grade 10 with care, purpose, and a push toward excellence. Recognized among the best middle schools in Hyderabad, we offer a curriculum that builds strong academics, life skills, and confidence.From Grade 6 onward, students get early exposure to IIT-JEE and NEET foundation courses alongside regular subjects like Science, Mathematics, Languages, and Social Studies. Teachers encourage critical thinking, collaboration, and personal growth through projects, debates, labs, and leadership roles.At Rankridge, this phase is not just about scoring well.it’s about equipping young minds with resilience, curiosity, and the ability to dream big."


const SchoolIIT_JEE = () => {
  return (
    <div> 
<h1 className="text-center text-2xl font-bold m-3"> Best IIT-JEE & NEET Foundation School in Hyderabad for<br></br> Grades 6 to 10
</h1>

               <CommonAboutHeader  images={iit} title={title} des={description}/>

     {/* <CommonImageSlider  images={iit}/> */}
     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
{/* <h2 className="text-xl text-center capitalize   sm:text-xl font-semibold text-[black]  m-2"> Turning ambition into top ranks  Rankridge IIT-JEE & NEET Foundation.
    </h2>
   <section className="m-4">
        <h2 className="text-2xl font-bold text-center mb-4">
          About Rankridge IIT-JEE &amp; NEET Foundation Program
        </h2>
        <p className="text-gray-700 text-justify">
          At Rankridge School, we believe every great achievement begins with a strong
          foundation. Our integrated foundation course for Grades 6 to 10 is designed to prepare
          students early for IIT-JEE Mains &amp; Advanced, NEET-UG, Olympiads, NTSE, and other
          competitive exams. By combining strong conceptual learning with exam strategy, we ensure
          students are ready to excel by the time they enter Grade 11.
        </p>
      </section> */}

      <div className="bg-[#20b2aa] text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12 space-y-12">
        {/* Tagline */}
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-2xl font-semibold mb-2">
            Rankridge School – Your Early Start to IIT-JEE &amp; NEET Excellence
          </h2>
          <p className="mb-3">
            Every great achievement starts with a strong foundation. Early preparation is the key
            to cracking India’s toughest competitive exams like IIT-JEE Mains &amp; Advanced,
            NEET-UG, and Olympiads. Our integrated foundation course for Grades 6 to 10 nurtures
            young minds, sharpens skills, and sets students on the path to academic excellence.
          </p>
        </div>

        {/* Why Start Early */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-3 text-black">
              Why Start Early? The Power of Foundation Learning
            </h3>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {whyStartEarly.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <p className="mt-3 text-gray-700">
              This approach ensures that by the time students reach Grade 11, they are already
              ahead of the curve—confident, consistent, and conceptually strong.
            </p>
          </div>

          {/* Faculty */}
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-3 text-black">
              Expert Faculty – Mentors Who Inspire &amp; Guide
            </h3>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>
                Highly qualified faculty from IITs, NITs, and AIIMS with years of mentoring
                experience.
              </li>
              <li>Personalized guidance tailored to each student’s learning pace.</li>
              <li>Ongoing clarity sessions to ensure complete understanding.</li>
              <li>Mentorship that nurtures discipline, focus, and self-confidence.</li>
            </ul>
          </div>

          {/* Facilities */}
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-3 text-black">
              World-Class Facilities for Competitive Excellence
            </h3>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {facilities.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </div>

          {/* Success */}
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-3 text-black">Proven Track Record of Success</h3>
            <p className="text-gray-700 mb-2">
              Rankridge learners repeatedly secure leading positions in major competitive exams:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {exams.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
            <p className="mt-3 text-gray-700">
              Our results speak louder than words—year after year, Rankridge students enter India’s
              top engineering and medical colleges.
            </p>
          </div>
        </div>

        {/* Closing + CTA */}
        <div className="space-y-8">
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-2 text-black">
              Your Child’s Journey to Success Starts Here
            </h3>
            <p className="text-gray-700">
              Looking for the best IIT-JEE foundation school in Hyderabad or the most trusted NEET
              foundation program in Hyderabad? Rankridge’s Grades 6 to 10 program is more than
              academics—it’s about shaping confident, capable, and future-ready achievers.
            </p>
          </div>

          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h3 className="text-lg font-bold mb-3 text-black">Admissions Open – Grades 6 to 10</h3>
            <p className="text-gray-700">
              Seats are limited—give your child the Rankridge advantage today!
            </p>
            <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
              <div className="bg-[#20b2aa] text-white p-4 rounded-lg">
                <p className="font-semibold">📍 Location</p>
                <p>Hyderabad</p>
              </div>
              <a
                href="tel:+919959303873"
                className="bg-[#20b2aa] text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
              >
                <p className="font-semibold">📞 Call Us</p>
                <p>+91 99 59 303 873</p>
              </a>
              <a
                href="https://www.rankridgeschools.com"
                target="_blank"
                rel="noreferrer"
                className="bg-[#20b2aa] text-white p-4 rounded-lg break-words focus:outline-none focus:ring-2 focus:ring-white"
              >
                <p className="font-semibold">🌐 Visit</p>
                <p>www.rankridgeschools.com</p>
              </a>
            </div>
          </div>
        </div>
      </div>
         <FAQ data={neetiitjee} />
                <SeoMeta seopages={seopages} />
    </div>
  );
};
export default SchoolIIT_JEE